import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=4d529a32&scoped=true"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"
import style0 from "./Printers.vue?vue&type=style&index=0&id=4d529a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d529a32",
  null
  
)

export default component.exports